import { render } from "./ImportGroupForm.vue?vue&type=template&id=2cc1cfd6&ts=true"
import script from "./ImportGroupForm.vue?vue&type=script&lang=ts"
export * from "./ImportGroupForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__